// Resolve image URLs.
// - /uploads/...   → served as a static asset by CRA devServer or nginx (no backend prefix)
// - /api/files/... → legacy cloud-proxy path, still proxied through backend
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  // Rewrite backend files path directly to static /uploads folder
  if (url.startsWith("/api/files/")) {
    return url.replace("/api/files/", "/uploads/");
  }
  // New local-disk path — served statically, no backend needed
  if (url.startsWith("/uploads/")) return url;
  // Legacy
  if (url.startsWith("/api/")) return `${BACKEND}${url}`;
  return url;
};

// Recursively resolve any *image_url field in a content object (one level deep on arrays)
export const resolveContent = (content) => {
  if (!content) return content;
  const c = JSON.parse(JSON.stringify(content));
  if (c.hero?.image_url) c.hero.image_url = resolveImage(c.hero.image_url);
  if (c.hero?.title_image_url) c.hero.title_image_url = resolveImage(c.hero.title_image_url);
  if (c.team?.image_url_1) c.team.image_url_1 = resolveImage(c.team.image_url_1);
  if (c.team?.image_url_2) c.team.image_url_2 = resolveImage(c.team.image_url_2);
  if (c.chef?.image_url) c.chef.image_url = resolveImage(c.chef.image_url);
  if (c.menu?.pdf_url) c.menu.pdf_url = resolveImage(c.menu.pdf_url);
  if (c.menu?.wine_pdf_url) c.menu.wine_pdf_url = resolveImage(c.menu.wine_pdf_url);
  if (c.menu?.categories) {
    c.menu.categories = c.menu.categories.map((cat) => ({
      ...cat,
      image_url: resolveImage(cat.image_url),
    }));
  }
  if (c.gallery?.images) {
    c.gallery.images = c.gallery.images.map((img) => ({
      ...img,
      url: resolveImage(img.url),
    }));
  }
  return c;
};
